import psbIconUrl from '@/assets/psb-icon.png'

/** China public security bureau (公安备案) registration — use exactly as provided. */
export const CHINA_PSB_FILING = {
  operatorName: '重庆安碳工业技术有限公司',
  recordNumber: '渝公网安备50010602505230号',
  recordCode: '50010602505230',
  authority: '沙坪坝区网安支队',
  registeredAt: '2026-06-15',
} as const

export function getChinaPsbFilingVerificationUrl(recordCode: string): string {
  return `https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${recordCode}`
}

export const CHINA_PSB_FILING_VERIFICATION_URL =
  getChinaPsbFilingVerificationUrl(CHINA_PSB_FILING.recordCode)

/** Official 公安备案 badge used on Chinese compliance footers. */
export const CHINA_PSB_FILING_BADGE_URL = psbIconUrl
